<div class="question-action">
  <form [formGroup]="questionForm" (submit)="submit()">
    <app-input-wrapper>
      <label>Question <span>*</span></label>
      <input
        formControlName="question"
        inNoWhitespace
        placeholder="Write your question here..."
        maxlength="200"
      />
      <span
        *ngIf="questionForm.get('question')?.errors?.['required']&&(questionForm.get('question')?.dirty||questionForm.get('question')?.touched)"
      >
        This field is required
      </span>
    </app-input-wrapper>
    <app-input-wrapper>
      <label>Answer <span>*</span></label>
      <app-custom-editor
        controlName="answer"
        [form]="questionForm"
      ></app-custom-editor>
      <span
        *ngIf="questionForm.get('answer')?.errors?.['required']&&(questionForm.get('answer')?.dirty||questionForm.get('answer')?.touched)"
      >
        This field is required
      </span>
    </app-input-wrapper>
    <div class="flex justify-end">
      <app-button
        [type]="'button'"
        [label]="reset ? 'Reset' : 'Cancel'"
        customClass="outline"
        (action)="handleClose()"
      ></app-button>
      <app-button
        [type]="'submit'"
        [label]="reset ? 'Add Question' : 'Submit'"
        [isDisabled]="loading"
      >
        <app-button-loader *ngIf="loading" postfixContent></app-button-loader>
      </app-button>
    </div>
  </form>
</div>
